import React, { useEffect } from 'react';
import { ChatAnalytics, Message, TrackFunction } from './types';
import { ChatMessage } from './ChatMessage';
import { scrollToBottom } from './utils';
import { ChatTopics } from './ChatTopics';

type ChatWindowProps = {
	messages: Message[];
	topics: string[];
	loading: boolean;
	onSubmit: (topic: string) => void;
	analytics: ChatAnalytics;
	track: TrackFunction;
};

export const ChatWindow = ({ messages, topics, loading, onSubmit, analytics, track }: ChatWindowProps) => {
	useEffect(() => {
		scrollToBottom('chat-scroll-container');
	}, [messages, topics]);
	return (
		<div data-testid="chat-scroll-container" id="chat-scroll-container" className="flex-1 overflow-y-auto scroll-smooth">
			<ul className="space-y-12 grid grid-cols-1">
				{messages.map((message, i) => (
					<ChatMessage
						key={message.id}
						message={message}
						index={i}
						length={messages.length}
						loading={loading}
					/>
				))}
			</ul>
			<ChatTopics topics={topics} loading={loading} onSubmit={onSubmit} analytics={analytics} track={track} />
		</div>
					
	);
};
